export default __webpack_public_path__ + "static/media/ic_calendar.e1d4f349.svg";